import { Values } from '../../types/values';

export const CustomViewType = {
  taskProfile: 'TaskProfile',
} as const;

export type CustomViewTypes = Values<typeof CustomViewType>;
